"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _excluded = ["getOptionLabel", "getOptionValue", "getMenuProps", "getItemProps", "options", "isOpen", "selectedItem", "highlightedIndex", "optionRenderer", "verticalAlign", "className", "noResultsMessage"];

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var ResultList = function ResultList(_ref) {
  var getOptionLabel = _ref.getOptionLabel,
      getOptionValue = _ref.getOptionValue,
      getMenuProps = _ref.getMenuProps,
      getItemProps = _ref.getItemProps,
      options = _ref.options,
      isOpen = _ref.isOpen,
      selectedItem = _ref.selectedItem,
      highlightedIndex = _ref.highlightedIndex,
      optionRenderer = _ref.optionRenderer,
      verticalAlign = _ref.verticalAlign,
      className = _ref.className,
      noResultsMessage = _ref.noResultsMessage,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement("ul", _extends({}, rest, getMenuProps(), {
    className: (0, _classnames.default)('ln-c-dropdown-list', 'ln-c-dropdown-list--overlay', className)
  }), isOpen && (options.length > 0 ?
  /* eslint-disable jsx-a11y/role-supports-aria-props */
  options.map(function (option, index) {
    return /*#__PURE__*/_react.default.createElement("li", _extends({
      key: option + "-" + index,
      className: (0, _classnames.default)('ln-c-dropdown-list__item', verticalAlign && "ln-c-dropdown-list__item--align-" + verticalAlign, selectedItem === option && 'is-selected', highlightedIndex === index && 'is-hover')
    }, getItemProps({
      key: getOptionValue(option),
      item: option,
      index: index
    }), {
      "aria-selected": selectedItem === option || undefined,
      "data-attribute": option.label
    }), optionRenderer ? optionRenderer(option) : getOptionLabel(option));
  }) : /*#__PURE__*/_react.default.createElement("li", {
    className: (0, _classnames.default)('ln-c-dropdown-list__item', 'ln-c-dropdown-list__item--message', verticalAlign && "ln-c-dropdown-list__item--align-" + verticalAlign)
  }, noResultsMessage)));
};

ResultList.propTypes = {
  getOptionLabel: _propTypes.default.func.isRequired,
  getOptionValue: _propTypes.default.func.isRequired,
  getMenuProps: _propTypes.default.func.isRequired,
  getItemProps: _propTypes.default.func.isRequired,
  options: _propTypes.default.arrayOf(_propTypes.default.object),
  isOpen: _propTypes.default.bool,
  optionRenderer: _propTypes.default.func,
  selectedItem: _propTypes.default.shape({}),
  highlightedIndex: _propTypes.default.number,
  verticalAlign: _propTypes.default.string,
  className: _propTypes.default.string,
  noResultsMessage: _propTypes.default.node
};
ResultList.defaultProps = {
  options: [],
  isOpen: false,
  optionRenderer: undefined,
  selectedItem: undefined,
  highlightedIndex: undefined,
  verticalAlign: 'center',
  className: undefined,
  noResultsMessage: 'No results found'
};
ResultList.displayName = 'ResultList';
var _default = ResultList;
exports.default = _default;